import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "reference-item__header" }
const _hoisted_2 = {
  class: /*#__PURE__*/_normalizeClass(['reference-task'])
}
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_BaseCaption = _resolveComponent("BaseCaption")!
  const _component_ReferenceComponentParentList = _resolveComponent("ReferenceComponentParentList")!

  return (_openBlock(), _createBlock(_component_ReferenceComponentParentList, {
    searchList: _ctx.result,
    componentType: _ctx.componentType,
    selectedIndex: _ctx.selectedIndex,
    onOnClick: _ctx.onSelectItem
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(['reference-item', `is-${_ctx.currentItem?.itemTypeParsed.id.toLowerCase()}`])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_BaseSubHeading, {
            weight: "500",
            size: "medium",
            color: "monochrome-06"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" #" + _toDisplayString(_ctx.currentItem?.sequenceNumber), 1)
            ]),
            _: 1
          }),
          _createElementVNode("span", {
            class: _normalizeClass(['reference-item__status', `is_${_ctx.currentItem?.statusParsed?.id.toLowerCase()}`])
          }, _toDisplayString(_ctx.currentItem?.statusParsed?.label), 3)
        ]),
        _createVNode(_component_BaseSubHeading, {
          size: "small",
          weight: "500",
          color: "monochrome-05",
          darkColor: "monochrome-07",
          className: "reference-item__body"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.currentItem?.title), 1)
          ]),
          _: 1
        })
      ], 2)
    ]),
    item: _withCtx(({ option }) => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_BaseCaption, {
          size: "large",
          color: "monochrome-05",
          className: "reference-item__order"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(option.order), 1)
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_BaseCaption, {
          size: "large",
          color: "monochrome-06",
          className: "reference-task__body"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              innerHTML: option.name
            }, null, 8, _hoisted_3)
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_BaseCaption, {
          size: "large",
          color: "monochrome-05"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(option.typeParsed.label), 1)
          ]),
          _: 2
        }, 1024)
      ])
    ]),
    _: 1
  }, 8, ["searchList", "componentType", "selectedIndex", "onOnClick"]))
}